import { render, staticRenderFns } from "./IntegrationModule.vue?vue&type=template&id=6523f9e2&"
import script from "./IntegrationModule.vue?vue&type=script&lang=js&"
export * from "./IntegrationModule.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports